import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/app'
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { setupStore } from './services/store';
import { sendError } from './services/api';
import "cesium/Build/Cesium/Widgets/widgets.css";
import "@arcgis/core/assets/esri/themes/light/main.css";
import './viewer.css'
import "./arcgis-viewer.css"
import esriConfig from "@arcgis/core/config.js";
import {NavigationBlockerProvider} from "./components/home/header/navigation/navigation-blocker/navigation-blocker";

if (process.env.REACT_APP_ERROR_API_URL && process.env.REACT_APP_ERROR_API_URL.length) {
  window.onerror = function(message, source, lineno, colno, error) {
    const stackTrace = `${source}: lin(${lineno}), col(${colno}).`;
    sendError(process.env.REACT_APP_ERROR_API_URL as string, {
      message: message.toString(),
      stackTrace: error?.stack ?? stackTrace,
      description: error?.message,
      url: window.location.toString()
    })
    return true;
  }
}

if (process.env.REACT_APP_ASSETS_PATH)
  esriConfig.assetsPath = process.env.REACT_APP_ASSETS_PATH;

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

const store = setupStore()

root.render(
  <Provider store={store}>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <NavigationBlockerProvider>
        <App />
      </NavigationBlockerProvider>
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);